module.exports = __webpack_public_path__ + "img/bs-app.598b191a.png";